import classNames from 'classnames';
import * as React from 'react';

import SingleSelect from '../../fields/select/SingleSelect';

import type { BaseTabsProps } from './base.tabs.props';

const BaseTabs: React.FC<BaseTabsProps> = function(props) {
  const {
          active,
          changeTab,
          children,
          className,
          disabled,
          forceTabs,
          nav = [],
          title,
          useSelect = true,
        } = props;

  const [collapsed, setCollapsed] = React.useState(false);

  const options = React.useMemo(() => {
    return nav.map((tab, index) => {
      return {
        label: tab.label,
        value: index,
      };
    });
  }, [nav]);

  const handleChangeTab = React.useCallback((index: number) => {
    if (disabled !== index) {
      changeTab(index);
    }
  }, [disabled, changeTab]);
  const handleClick     = React.useCallback((event: React.MouseEvent<HTMLLIElement>, index: number) => {
    event.preventDefault();
    event.stopPropagation();

    handleChangeTab(index);
  }, [handleChangeTab]);
  const handleResize    = React.useCallback(() => {
    if (window.screen.width <= 990) {
      if (!collapsed && !forceTabs && !collapsed) {
        setCollapsed(true);
      }
    } else if (collapsed) {
      setCollapsed(false);
    }
  }, [collapsed, forceTabs]);

  React.useEffect(() => {
    handleResize();

    window.addEventListener('orientationchange', handleResize);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('orientationchange', handleResize);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className={'tabbable'}>
      {(typeof title === 'string' || nav.length > 0) && (
        <div className={'top'}>
          {typeof title === 'string' && <div className="title">{title}</div>}
          {nav.length > 0 && (
            <>
              {collapsed && useSelect
                ? (
                  <SingleSelect
                    onChangeCallback={handleChangeTab}
                    options={options}
                    required
                    selected={active}
                    valueKey={'value'}
                  />
                )
                : (
                  <ul className={classNames('tabs', className)}>
                    {nav.map((tab, index) => {
                      return (
                        <li
                          className={classNames({ active: active === index })}
                          key={index}
                          onClick={(event) => {
                            handleClick(event, index);
                          }}
                        >{tab.label}</li>
                      );
                    })}
                  </ul>
                )
              }
            </>
          )}
        </div>
      )}
      {children && (
        <div className={'tab-content'}>
          {React.Children.map(children, (child, index) => {
            if (active !== index) {
              return null;
            }
            return (
              <div
                className={classNames('tab-pane', { active: active === index })}
                key={index}
              >{child}</div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default BaseTabs;